// Standard welcome message shown at the start of a video chat when no custom
// initial message is configured. Used as the display-time fallback in
// ChatInterface and pre-filled into the school content form.
export const DEFAULT_VIDEO_INITIAL_MESSAGE = '質問や壁打ちをしたい場合はこちらに入力してください。'
